import { Component, OnInit, Input } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ChangeEscrowComponent} from '../../../../child-component/change-escrow/change-escrow.component';
@Component({
  selector: 'app-overview-interested-parties',
  templateUrl: './overview-interested-parties.component.html',
  styleUrls: ['./overview-interested-parties.component.scss']
})
export class OverviewInterestedPartiesComponent implements OnInit {
  @Input() job: any;
  // Inspectors see Escrow # / Closing Date read-only, as in twin-ci.
  @Input() canEditEscrow = true;
  // Inspectors do not see the Buyer, as in twin-ci.
  @Input() showBuyer = true;
  constructor(
    config : NgbModalConfig,
    private modalService: NgbModal
  ) { 
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit() {
  }
  openFormModal() {
    const modalRef = this.modalService.open(ChangeEscrowComponent);
    modalRef.componentInstance.job = this.job;
    modalRef.result.then((result) => {
     this.job['job_escrow_number']= result.job_escrow_number
     this.job['job_escrow_closing_date']= result.job_escrow_closing_date
    }).catch((error) => {
        console.log(error);
    });
  }

}
